import ProductsRequests from '../../server/products';
import { addLoading, removeLoading } from './loading';

export const setProducts = res => ({
  type: 'GET_PRODUCTS',
  products: res,
});

export const setProductsCheckbuy = res => ({
  type: 'GET_PRODUCTS_CHECKBUY',
  productsCheckbuy: res,
});

export const setProductsCount = res => ({
  type: 'GET_PRODUCTS_COUNT',
  count: res,
});
export const setProductsSearched = res => ({
  type: 'GET_PRODUCTS_SEARCH',
  searched: res,
});

const getProducts = (limit, skip) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const products = await ProductsRequests.getProducts(limit, skip);
    dispatch(setProducts(products));
  } finally {
    dispatch(removeLoading());
  }
};

const searchProductsCheckbuy = (limit, search, loading = true) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    dispatch(setProductsCheckbuy(''));
    const products = await ProductsRequests.searchProductsCheckbuy(limit, search);
    dispatch(setProductsCheckbuy(products));
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

const searchProductsCheckbuyTelecom = (limit, search, loading = true) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    dispatch(setProductsCheckbuy(''));
    const products = await ProductsRequests.searchProductsCheckbuyTelecom(limit, search);
    dispatch(setProductsCheckbuy(products));
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

const getSearchProducts = (limit, search, loading = true) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    dispatch(setProductsSearched(''));
    const searched = await ProductsRequests.getSearchProducts(limit, search);
    dispatch(setProductsSearched(searched));
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

const getSearchPanelProducts = (limit, skip, search, order = '', field = '') => async (dispatch) => {
  if (!search) dispatch(addLoading());
  try {
    dispatch(setProductsSearched(''));
    const products = await ProductsRequests.getSearchPanelProducts(limit, skip, search, order, field);
    dispatch(setProducts(products));
  } finally {
    if (!search) dispatch(removeLoading());
  }
};

const updateProductSpotlight = (soneparId, spotlight) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ProductsRequests.updateProductSpotlight(soneparId, spotlight);
  } finally {
    dispatch(removeLoading());
  }
};

const updateProductIsSpot = (soneparId, isSpot) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ProductsRequests.updateProductIsSpot(soneparId, isSpot);
  } finally {
    dispatch(removeLoading());
  }
};

const updateProductIsDisable = (soneparId, isDisable) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ProductsRequests.updateProductIsDisable(soneparId, isDisable);
  } finally {
    dispatch(removeLoading());
  }
};

const updateProduct = product => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ProductsRequests.updateProduct(product);
  } finally {
    dispatch(removeLoading());
  }
};

const saveProduct = product => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ProductsRequests.saveProduct(product);
  } finally {
    dispatch(removeLoading());
  }
};

const deleteProduct = soneparId => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ProductsRequests.deleteProduct(soneparId);
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadProducts = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await ProductsRequests.uploadCsvProducts(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvProductModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ProductsRequests.getCsvProductModel();
  } finally {
    dispatch(removeLoading());
  }
};

const getCsvProductsReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ProductsRequests.getCsvProductsReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const disableProductsByCategory = categoryId => async (dispatch) => {
  dispatch(addLoading);
  try {
    return await ProductsRequests.disableProductsByCategory(categoryId);
  } finally {
    dispatch(removeLoading);
  }
};

export default {
  getProducts,
  searchProductsCheckbuy,
  searchProductsCheckbuyTelecom,
  getSearchProducts,
  getSearchPanelProducts,
  saveProduct,
  updateProductSpotlight,
  updateProductIsSpot,
  updateProductIsDisable,
  updateProduct,
  deleteProduct,
  uploadProducts,
  getCsvProductModel,
  getCsvProductsReport,
  disableProductsByCategory,
};
